<template>
  <!--    Loan Payment Form-->
  <validation-observer
    ref="loanPaymentForm"
    v-slot="{invalid}"
  >
    <sikanii-modal
      title="Record Loan Repayments"
      :show="loanPaymentOpened"
      :show-overlay="deletingLoanPayment"
      size="md"
      @onClose="closeLoanPaymentModal()"
    >
      <b-row class="align-items-start">
        <div class="col-12">
          <sikanii-button
            name="loan_payment_action"
            variant="flat-danger"
            icon="XIcon"
            label="Clear Form"
            class="float-right"
            tool-tip-text="Clear Form"
            @click="resetLoanPaymentForm()"
          />
        </div>
      </b-row>
      <error-display :error="error" />
      <div class="d-flex justify-content-center">
        <div
          v-if="selectedCustomer"
          class="d-flex flex-column text-center"
        >
          <sikanii-profile-photo
            class="mb-50"
            size="100"
            :photo="selectedCustomer.photo"
            preview
          />
          <b>{{ selectedCustomer.full_name }}({{ selectedCustomer.reference }})</b>
          <b>Ph: {{ selectedCustomer.phone }}</b>
          <b>Address: {{ selectedCustomer.address }}</b>
          <b>Loan: {{ selectedCustomer.loan_ref }}</b>
          <b>Balance: {{ $store.getters['auth/currency'] }}{{ selectedCustomer.balance | currency }}</b>
        </div>
      </div>
      <div
        class="mt-2"
      >
        <sikanii-input
          v-model="customerSearch"
          name="customer"
          enterkeyhint="search"
          placeholder="Enter Customer Name or ID + Enter"
          suffix-icon="SearchIcon"
          @onSuffixIconClick="handleSearchCustomer"
          @onEnterPressed="handleSearchCustomer"
        />
      </div>
      <sikanii-select
        v-model="loanPayment.customer_id"
        class="mt-2"
        label-name="full_name"
        value-name="id"
        name="customer"
        rules="required"
        label="Customer"
        placeholder="Select Customer"
        :options="customers"
        @input="handleCustomerChange"
      />
      <sikanii-input
        v-model="loanPayment.amount"
        name="amount"
        placeholder="Enter Loan Payment Amount"
        rules="required|gt:0"
        label="Amount"
        type="number"
      />
      <sikanii-text-area
        v-model="loanPayment.narration"
        name="narration"
        label="Narration"
        placeholder="Enter narration"
      />
      <template slot="modal-actions">
        <b-row class="float-right">
          <sikanii-button
            name="cancel"
            variant="flat-danger"
            icon="XIcon"
            class="mr-1"
            label="Cancel"
            @click="closeLoanPaymentModal()"
          />
          <sikanii-button
            name="save_loan_payment"
            label="Record"
            :disabled="invalid"
            :loading="loanPaymentLoading"
            loading-text="Loading..."
            @click="createLoanPayment()"
          />
        </b-row>
      </template>
    </sikanii-modal>
  </validation-observer>
</template>

<script>
import {
  BRow,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import SikaniiModal from '@/layouts/components/SikaniiModal.vue'
import SikaniiInput from '@/layouts/components/SikaniiInput.vue'
import SikaniiButton from '@/layouts/components/SikaniiButton.vue'
import showToast from '@/libs/mixins/showToast'
import logData from '@/libs/log'
import ErrorDisplay from '@/layouts/components/ErrorDisplay.vue'
import sexMixin from '@/libs/mixins/sexMixin'
import SikaniiProfilePhoto from '@/layouts/components/SikaniiProfilePhoto.vue'
import SikaniiTextArea from '@/layouts/components/SikaniiTextArea.vue'
import SikaniiSelect from '@/layouts/components/SikaniiSelect'

const loanPayment = {
  id: null,
  loan_id: null,
  customer_id: null,
  amount: null,
  narration: null,
}
export default {
  name: 'LoanPaymentSetup',
  components: {
    SikaniiSelect,
    SikaniiTextArea,
    SikaniiProfilePhoto,
    ErrorDisplay,
    SikaniiButton,
    SikaniiInput,
    SikaniiModal,
    ValidationObserver,
    BRow,
  },
  mixins: [showToast, sexMixin],
  props: {
    modalOpened: {
      type: Boolean,
      default: false,
    },
    editId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      error: {},
      loanPaymentOpened: false,
      loanPaymentLoading: false,
      deletingLoanPayment: false,
      selectedLoanPaymentId: null,
      loanPayment: { ...loanPayment },
      selectedCustomer: null,
      customerSearch: null,
      customers: [],
    }
  },
  computed: {

  },
  watch: {
    modalOpened(opened) {
      this.loanPaymentOpened = opened
    },
    editId(id) {
      this.selectedLoanPaymentId = id
    },
  },
  methods: {
    handleCustomerChange(id) {
      this.selectedCustomer = this.customers.find(c => c.id === id)
      this.loanPayment.customer_id = this.selectedCustomer.id
      this.loanPayment.loan_id = this.selectedCustomer.loan_id
    },
    handleSearchCustomer(search) {
      if (!search) {
        this.showInfo('Please enter a search term')
        return
      }
      this.error = {}
      this.deletingLoanPayment = true
      this.$http.get(`susu-savings/loans/customer?search=${search}&for_repayment=true`).then(res => {
        this.customers = res.data
        this.selectedCustomer = this.customers[0]
        this.loanPayment.customer_id = this.selectedCustomer.id
        this.loanPayment.loan_id = this.selectedCustomer.loan_id
      }).catch(err => {
        if (err.response.status === 404) {
          this.showInfo('No user found, try again')
        }
        this.error = err
      }).finally(() => {
        this.deletingLoanPayment = false
      })
    },
    resetLoanPaymentForm() {
      this.loanPayment = { ...loanPayment }
      this.selectedLoanPaymentId = null
      this.selectedCustomer = null
      this.customerSearch = null
      this.$refs.loanPaymentForm.reset()
    },
    closeLoanPaymentModal() {
      this.loanPaymentOpened = false
      this.$emit('modalClosed')
    },
    createLoanPayment() {
      this.error = {}
      this.loanPaymentLoading = true
      this.$http.post('susu-savings/loan-payments', this.loanPayment).then(res => {
        this.showSuccess('Loan Payment Recorded Successfully')
        this.$store.commit('loans/addLoanPayment', res.data)
        this.resetLoanPaymentForm()
      }).catch(err => {
        logData(err)
        this.error = err
        if (err.response.status === 402) {
          this.showInfo('Transactions are closed')
        } else {
          this.showError('Failed to record loan payment')
        }
      }).finally(() => {
        this.loanPaymentLoading = false
      })
    },
  }
  ,
}
</script>
